import { render, staticRenderFns } from "./index.vue?vue&type=template&id=088db0e5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/number-favourite/_number-favourite.scss?vue&type=style&index=0&id=088db0e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088db0e5",
  null
  
)

export default component.exports